import { AppRoutesUI } from "../config/appRoutes";
import { ForgetPasswordPage } from "../pages/auth/forgetPassword/forgetPasswordPage";
import { LoginPage, ResetPasswordPage } from "../pages/auth";
import { Navigate, Route, Routes } from "react-router-dom";
import { RedirectAuthorized } from "../utils/authRedirectHandlers";

export const PublicLayout = () => {
  return (
    <RedirectAuthorized>
      <Routes>
        <Route path={AppRoutesUI.Auth.Login.Route} element={<LoginPage />} />
        <Route
          path={AppRoutesUI.Auth.ForgetPassword.Route}
          element={<ForgetPasswordPage />}
        />
        <Route
          path={AppRoutesUI.Auth.ResetPassword.Route}
          element={<ResetPasswordPage />}
        />
        <Route path="/*" element={<Navigate to="/404" replace />} />
      </Routes>
    </RedirectAuthorized>
  );
};
